import { useQuery } from "@tanstack/react-query";
import { getBrandedSignupInfo } from "../api.js";

export const useAdvertiserBrandedInfo = (advertiserId) =>
  useQuery({
    queryKey: ["advertiser-branded-info", advertiserId],
    queryFn: () => getBrandedSignupInfo(advertiserId),
    enabled: !!advertiserId,
  });
